﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customWebpageEditItemList from './tpl/customWebpageEditItemList.html';
import View_CustomWebpageEditItemListItem from './customWebpageEditItemListItem';

export default Marionette.CollectionView.extend({
    tagName: 'ol',
    className: 'd-flex flex-column todo-list sortable ui-sortable mjs-nestedSortable-branch mjs-nestedSortable-expanded',
    attributes: function () {
        // Return model data
        return {
            class: 'side-links ui-sortable',
            //style : 'padding-left:0px;',
            id: 'customWebpageEditItemListItem'
        }

    },
    ui: {
        'customWebpageEditItemListItem': '#customWebpageEditItemListItem'
    },
    //childViewContainer: '#customWebpageEditItemList',
    childView: View_CustomWebpageEditItemListItem,

    getTemplate: function () {
        return tpl_customWebpageEditItemList();
    },
    initialize: function () {
        var self = this;
        this.app = this.options.app;
        this.childViewContainer = this.options.childViewContainer;

        var userChannel = Backbone.Radio.channel('app');
        this.listenTo(userChannel, 'customWebpageEditItemList:updateWebpagePositionNew', function (content) {
            self.updateWebpagePositionNew();
        });

        this.listenTo(userChannel, 'customWebpageEditItemList:reorder', function (content) {
            self.reorder();
        });
    },
    addChild: function (model, ChildView, index) {
        if (model.get('Tag') == 1 && model.get('Position') > 1 ||
            model.get('Tag') == 10) {
            return Marionette.CollectionView.prototype.addChild.call(this, model, ChildView, index);
        }
    },
    buildChildView: function (child, ChildViewClass, childViewOptions) {
        var options = _.extend({ model: child }, childViewOptions);
        options.app = this.app;
        var view = new ChildViewClass(options);
        return view;
    },
    onAttach() {
        var self = this;
        /*$('#customWebpageEditItemListItem').sortable({
            items: "li:not(.ui-state-disabled)",
            connectWith: '.sort_these',
            stop: function (event, ui) {
                self.updateWebpagePosition();
            }
        });*/


        $('#customWebpageEditItemListItem').nestedSortable({
            forcePlaceholderSize: true,
            handle: 'div',
            helper: 'clone',
            items: 'li',
            listType: 'ol',
            opacity: .6,
            placeholder: 'placeholder',
            revert: 250,
            tabSize: 25,
            tolerance: 'pointer',
            toleranceElement: '> div',
            maxLevels: 2,
            isTree: true,
            expandOnHover: 700,
            startCollapsed: false,
            sort: function () {
                
                self.updateWebpagePositionNew();
                //self.reorder();
            },
            change: function () {
                console.log('Relocated item');
                
                //self.updateWebpagePositionNew();
                self.reorder();
            },
            isAllowed: function (placeholder, placeholderParent, currentItem) {
                var ret = false;
                var itemCanMove = false;
                var id = '';

                if (currentItem != undefined && currentItem[0].id != undefined) {
                    id = '#' + currentItem[0].id;
                    if ($(id).hasClass('mjs_canmove')) {
                        itemCanMove = true;
                        ret = true;
                    }
                }
                if (placeholderParent != undefined && placeholderParent[0].id != undefined) {
                    id = '#' + placeholderParent[0].id;
                    if ($(id).hasClass('mjs_dropdown')) {
                        if (!itemCanMove)
                            ret = false;
                    } else {
                        ret = true;
                    }
                }

                return true;
            }
        });

        $('#customWebpageEditItemListItem li').each(function (index, item) {
            var value = parseInt($(item).data('id'));
            var tmpModel = self.collection.where({ id: value });

            switch (tmpModel[0].attributes.Tag) {
                case 3:
                    $(item).attr("style", "display: none !important");
                    $(item).css('display', 'none !important;');
                    break;

                case 6:
                    $(item).attr("style", "display: none !important");
                    $(item).css('display', 'none !important;');
                    break;
            }
        });

        this.reorder();
    },
    /*render: function () {
        //this.reorder();
    },*/
    reorder: function () {
        //$('.menuDiv').removeClass('mjs_select');

        this.collection.forEach(function (entry) {
            //if (entry.attributes.Selected) {
            //    var id_from = '#customWebpageEditItemListItem_li_' + entry.attributes.id;
            //    $(id_from).closest('.menuDiv').addClass('mjs_select');
            //}
            //if (entry.attributes.Parent != -1) {
                //Remove li tag
                var id_from = '#customWebpageEditItemListItem_li_' + entry.attributes.id;
                var id_to = '#customWebpageEditItemListItem_li_' + entry.attributes.Parent;
                var id_ol = '#customWebpageEditItemListItem_ol_' + entry.attributes.Parent;


                //var ol = $(id_to).find("ol");
                var ol = $(id_ol);

                //$(id_from).closest('.li').remove();
                //$(id_from).unwrap();
                $(id_from).appendTo($(ol));
            //}
        });
    },
    updateWebpagePositionNew() {
        var self = this;

        $('.li_Body').each(function (i, ele) {
            if ($(ele).parents('ol') && !$(ele).parents('ol').hasClass('mjs_parent_ol')) {
                if ($(ele).attr('id') != 'customWebpageEditItemListItem')
                    $(ele).parents('ol').addClass('mjs_parent_ol');
            }
        });

        //Remove all mjs_dropdown
        $('.mjs_dropdown').removeClass('mjs_dropdown');

        this.collection.forEach(function (entry) {
            if (entry.attributes.Dropdown == true) {
                entry.attributes.Dropdown = false;
            }
            if (entry.attributes.Parent != -1) {
                entry.attributes.Parent = -1;
            }
        });

        //Set all that has child item to dropdown
        $('#customWebpageEditItemListItem li').each(function (index, item) {
            if ($(item).parents('.mjs_parent_ol').length) {
                $(item).parents('.li_Body').addClass('mjs_dropdown');
                var parentId = parseInt($(item).parents('.li_Body').data('id'));

                if (!isNaN(parentId)) {
                    var tmpModel = self.collection.where({ id: parentId });
                    tmpModel[0].attributes.Dropdown = true;
                }
            }
        });

        //Set all parent on a child that has a parent 
        $('#customWebpageEditItemListItem li').each(function (index, item) {
            var value = parseInt($(item).data('id'));
            if (value) {
                var tmpModel = self.collection.where({ id: value });

                if ($(item).parents('.mjs_parent_ol').length) {
                    if ($(item).parents('.mjs_dropdown').length) {
                    //if ($(item).parents('.mjs_canmove').length) {
                        var parentId = parseInt($(item).parents('.mjs_dropdown').data('id'));
                        tmpModel[0].attributes.Parent = parentId;
                        tmpModel[0].attributes.Dropdown = false;
                    }
                }
            }
        });

        //Update all position
        var nextPosition = 2;
        $('#customWebpageEditItemListItem li').each(function (index, item) {
            var value = parseInt($(item).data('id'));
            if (value) {
                var tmpModel = self.collection.where({ id: value });

                tmpModel[0].attributes.Position = nextPosition;
                nextPosition++;
            }
        });

    },
    updateWebpagePosition() {
        var selectedModel = this.collection.where({ Selected: true });
        if (selectedModel.length > 0) {
            var zeroIndex = -1;
            switch (selectedModel[0].attributes.DisplayType) {
                case 0: zeroIndex = 0; break;
                case 1: zeroIndex = -1; break;
            }
            var self = this;
            $('#customWebpageEditItemListItem li').each(function (index, item) {
                var value = parseInt($(item).data('id'));
                //var liId = parseInt(String($(this).data('id')));
                var tmpModel = self.collection.where({ id: value });
                if (tmpModel[0].attributes.Position != zeroIndex
                    && tmpModel[0].attributes.Position != 2147483647
                    && tmpModel[0].attributes.Position != 2147483646
                    && tmpModel[0].attributes.Position != 2147483645
                    && tmpModel[0].attributes.Position != 2147483644
                    && tmpModel[0].attributes.Position != 2147483643
                    && tmpModel[0].attributes.Position != 2147483642
                    && tmpModel[0].attributes.Position != 2147483641
                    && tmpModel[0].attributes.Position != 2147483640
                    && tmpModel[0].attributes.Position != 2147483639
                    && tmpModel[0].attributes.Position != 2147483638
                    && tmpModel[0].attributes.Position != index) {
                    tmpModel[0].attributes.Position = index;
                }
            });
        }
        $('#customWebpageEditItemListItem li').each(function (index, item) {
            var value = parseInt($(item).data('id'));
            var tmpModel = self.collection.where({ id: value });

            switch (tmpModel[0].attributes.Tag) {
                case 3:
                    $(item).attr("style", "display: none !important");
                    $(item).css('display', 'none !important;');
                    break;

                case 6:
                    $(item).attr("style", "display: none !important");
                    $(item).css('display', 'none !important;');
                    break;
            }
        });
    }
});
